function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { MDText } from 'i18n-react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import merge from 'lodash.merge';
import { getOrCreateGlobalContext } from '@adsk/alloy-react-context';
export var LocaleContext = getOrCreateGlobalContext('NirvanaLocaleContext');
export var LocaleProvider = LocaleContext.Provider;
export var LocaleConsumer = LocaleContext.Consumer;
export var useLocale = function useLocale() {
  return React.useContext(LocaleContext) || 'en';
};
export var useT = function useT(locales) {
  var locale = useLocale();
  var keys = locale === 'en' ? locales['en'] : merge({}, locales['en'], locales[locale]);
  var T = new MDText(keys);
  T.locale = locale;
  return T;
};
export var withT = function withT(Component, locales) {
  var LocalizedComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var T = useT(locales);
    return /*#__PURE__*/React.createElement(Component, _extends({
      ref: ref
    }, props, {
      T: T
    }));
  });
  var componentName = Component.displayName || Component.name || 'Component';
  LocalizedComponent.displayName = "Localized" + componentName;
  LocalizedComponent.defaultProps = Component.defaultProps;
  LocalizedComponent.propTypes = Component.propTypes;
  return hoistNonReactStatics(LocalizedComponent, Component);
};
//# sourceMappingURL=index.js.map